export const handleGetOneData = (data, id) => {
  const foundItem = data.find((d) => d.id === id);
  return foundItem;
};
